import React, { useState } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import ContactModal from './ContactModal';

const MentorshipSection: React.FC = () => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#1a1a1a',
          color: 'white',
          py: { xs: 8, md: 12 },
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ maxWidth: '900px', mx: 'auto', textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 900,
                fontFamily: '"Impact", sans-serif',
                mb: 4,
                textTransform: 'uppercase',
              }}
            >
              Want to Learn More About the Tech World?
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: '1.125rem', md: '1.25rem' },
                lineHeight: 1.8,
                mb: 4,
              }}
            >
              At my mentorship program, you'll work with guidance that values your growth and expertise. 
              My philosophy is simple – help driven individuals who foster a culture of continuous learning 
              and innovation in the tech industry.
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: '1.125rem', md: '1.25rem' },
                lineHeight: 1.8,
                mb: 6,
              }}
            >
              Whether you're starting your journey in software engineering, looking to specialize in AI, 
              or want to level up your cloud infrastructure skills, I'm here to help you navigate the 
              ever-evolving tech landscape. Write me and let's discuss how I can help you grow!
            </Typography>

            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                onClick={() => navigate('/mentorship')}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#dc143c',
                  color: 'white',
                  px: 5,
                  py: 2,
                  fontSize: '1.125rem',
                  fontWeight: 700,
                  border: '2px solid #dc143c',
                  '&:hover': {
                    backgroundColor: '#b01030',
                    borderColor: '#b01030',
                  },
                }}
              >
                Learn More
              </Button>
              
              <Button
                variant="outlined"
                onClick={handleOpenModal}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  borderColor: '#dc143c',
                  color: 'white',
                  px: 5,
                  py: 2,
                  fontSize: '1.125rem',
                  fontWeight: 700,
                  border: '2px solid #dc143c',
                  '&:hover': {
                    borderColor: '#b01030',
                    backgroundColor: 'rgba(220, 20, 60, 0.1)',
                  },
                }}
              >
                Get in Touch
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>

      <ContactModal open={modalOpen} onClose={handleCloseModal} type="mentorship" />
    </>
  );
};

export default MentorshipSection;